import React, { useEffect, useState } from "react";
import FileUploaderLocal from "./FileUploaderLocal";

export interface FileProps {
  file_id: string;
  file_name: string;
  url: string;
  created?: string;
}

interface IProps {
  name?: string;
  containerClassName?: string;
  files?: FileProps[];
  onChange?: (value: File[], name: string) => void;
  onBlur?: (name: string) => void;
  multiple?: boolean;
  labelName?: string;
  onRemove?: (id: string) => void;
  setInProgress?: (value: boolean) => void;
  maxFileSize?: number; // in bytes
  fileTypes?: string[];
  fileIcon?: React.ReactElement;
}

const FileUploader = ({
  name = "",
  containerClassName,
  files = [],
  onChange,
  onBlur,
  multiple,
  labelName,
  onRemove,
  fileTypes = [".pdf"],
  ...props
}: IProps) => {
  const [selectedfiles, setSelectedFiles] = useState<File[]>([]);
  const [uploadedFiles, setUploadedFiles] = useState<FileProps[]>([]);

  useEffect(() => {
    return () => setUploadedFiles([]);
  }, []);

  useEffect(() => {
    if (!multiple && selectedfiles.length > 0) {
      setSelectedFiles([]);
    }

    setUploadedFiles((prev) => {
      const hasChanged =
        prev.length !== files.length ||
        prev.some(
          (file, i) =>
            file.file_id !== files[i]?.file_id || file.url !== files[i]?.url
        );

      return hasChanged ? files : prev;
    });
  }, [files, multiple]);

  const removeUploadedFiles = (id: string) => {
    const files = uploadedFiles.filter((item) => item.file_id !== id);
    setUploadedFiles(files);
    onRemove && onRemove(id);
  };

  const handleFileChanged = async (filesList: File[] | FileList) => {
    if (!multiple) {
      setSelectedFiles([]);
      removeUploadedFiles(uploadedFiles[0]?.file_id);
    }

    const files = Array.from(filesList);
    const newState = [...selectedfiles, ...files];
    setSelectedFiles(newState);
    onChange && onChange(newState, name);
  };

  useEffect(() => {
    onBlur && onBlur(name);
  }, [selectedfiles]);

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files) return;
    handleFileChanged(e.target.files);
  };

  const onRemoveSelected = (file: File) => {
    const filteredItems = selectedfiles.filter((item) => item != file);
    setSelectedFiles([...filteredItems]);
    onChange && onChange(filteredItems, name);
  };

  return (
    <FileUploaderLocal
      name={name}
      labelName={labelName}
      multiple={multiple}
      containerClassName={containerClassName ?? ""}
      onChange={handleOnChange}
      onDraged={handleFileChanged}
      onRemoveSelected={onRemoveSelected}
      uploadedFiles={uploadedFiles}
      setInProgress={props.setInProgress}
      removeUploadedFiles={removeUploadedFiles}
      fileTypes={fileTypes}
      {...props}
    ></FileUploaderLocal>
  );
};

export default FileUploader;
